// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.q-grid-container * {
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
}

.q-grid-container {
  position: relative;
  overflow-x: auto;
  width: auto;
  height: auto;
  border-radius: 4px;
  color: #111111;
}

.q-grid-container .hidden {
  display: none !important;
}

.q-grid-container a {
  color: #337ab7 !important;
  text-decoration: none;
  line-height: 20px;
}

.q-grid-container a:hover,
.q-grid-container a:focus {
  color: #23527c;
  text-decoration: underline;
}

.q-grid {
  position: relative;
  border: 1px solid #d3d3d3;
  margin-top: 6px;
  margin-bottom: 2px;
  box-sizing: border-box;
}

.q-grid-toolbar {
  margin: 4px 0
}

.q-grid-toolbar .btn {
  background-color: #EEEEEE;
  border-color: #E0E0E0;
  margin-right: 6px;
  padding: 4px 40px;
  /* taken from bootstrap's btn class, since
     jupyterlab doesn't include bootstrap css */
  display: inline-block;
  margin-bottom: 0;
  font-weight: normal;
  text-align: center;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid #E0E0E0;
  white-space: nowrap;
  font-size: 13px;
  line-height: 1.42857143;
  border-radius: 2px;
}

.q-grid-toolbar .btn:hover {
  background-color: #DDDDDD;
  border-color: #CCCCCC;
}

.q-grid-toolbar .btn:focus {
  outline: none;
}

.q-grid-toolbar .close-modal-btn {
  display: none;
}

.qgrid-modal .q-grid-toolbar .close-modal-btn {
  display: block;
}

.qgrid-modal .full-screen-btn,
.qgrid-modal .modal-header,
.qgrid-modal .modal-footer {
  display: none;
}

.qgrid-modal {
  width: 100%;
  height: 100%;
  margin: 0px;
}

.qgrid-modal .modal-content {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
}

.qgrid-modal .modal-body {
  position: absolute;
  padding: 15px;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
}

.qgrid-modal .modal-body button.close {
  margin-top: 7px;
  margin-right: 14px;
}

.qgrid-modal .q-grid-container {
  bottom: 25px;
  left: 20px;
  right: 20px;
  position: absolute;
  top: 15px;
}

.qgrid-modal .q-grid {
  position: absolute;
  top: 33px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: auto !important;
}

.q-grid-toolbar .full-screen-btn,
.q-grid-toolbar .close-modal-btn {
  height: 18px;
  width: 12px;
  padding: 4px 7px;
  float: right;
  margin-right: 0px;
}

.output_scroll .q-grid {
  height: 315px !important;
}

.q-grid-toolbar {
  display: none;
}

.show-toolbar .q-grid-toolbar {
  display: block;
}

.output_scroll .show-toolbar .q-grid {
  height: 284px !important;
}

.q-grid.force-fit-columns .slick-viewport {
  overflow-x: hidden !important;
}

.q-grid.hide-scrollbar > .slick-header {
  margin-bottom: -1px;
}

.q-grid.hide-scrollbar > .slick-viewport {
  overflow-y: hidden !important;
  height: 100%;
}

.q-grid.hide-scrollbar.force-fit-columns > .slick-viewport {
  overflow: hidden !important;
}

.q-grid.hide-scrollbar > .slick-viewport > .grid-canvas {
  margin-top: 1px;
}

.q-grid .slick-header {
  border-top: none;
  border-left: none;
  border-right: none;
}

.q-grid .slick-header-columns,
.text-filter-grid .slick-header-columns {
  background: none;
  background-color: rgb(245, 245, 245);
  border-bottom: none;
}

.q-grid.force-fit-columns .slick-header-column:last-child .filter-button:hover,
.q-grid.force-fit-columns .slick-header-column.active:last-child .filter-button,
.q-grid.force-fit-columns .slick-header-column:last-child .filter-button.filter-active {
  border-right: 1px solid #ccc;
  margin-right: -4px;
}

.q-grid.force-fit-columns .slick-header-column:last-child .filter-button {
  margin-right: -4px;
  border-right: 1px solid transparent;
}

.q-qgrid.hide-scrollbar .slick-header-column:last-child .slick-resizable-handle {
  right: -4px;
}

.q-grid.hide-scrollbar > .slick_header .slick-header-column:last-child .filter-button,
.q-grid.hide-scrollbar > .slick-header .slick-header-column:last-child .filter-button:hover,
.q-grid.hide-scrollbar > .slick-header .slick-header-column.active:last-child .filter-button:hover,
.q-grid.hide-scrollbar > .slick-header .slick-header-column.active:last-child .filter-button.filter-active {
  border-right: 1px solid transparent;
}

.q-grid .slick-header-column .filter-button.filter-active,
.q-grid .slick-header-column .filter-button.filter-active:hover{
  background-color: #deeaf7;
  border-left: 1px solid #cccccc;
}

.q-grid .slick-header-column {
  background: rgb(245, 245, 245);
  color: #565656;
  border-right-style: none;
  font-size: 13px;
  font-weight: bold;
  padding: 6px 2px !important;
}

.q-grid .slick-header-column.active {
  background-color: #deeaf7;
}

.q-grid .slick-header-column-sorted {
  font-style: inherit !important;
}

.q-grid .slick-header-column:first-child .slick-column-name {
  margin-left: 6px !important;
}

.q-grid .slick-sort-indicator {
  height: 8px !important;
  margin-left: 6px;
}

.q-grid .slick-sort-indicator.fa-sort-asc {
  margin-top: 4px;
  color: #5862ff;
}

.q-grid .slick-sort-indicator.fa-sort-desc {
  margin-top: 1px;
  color: #5862ff;
}

.q-grid .slick-sort-indicator.fa-spinner {
  height: auto !important;;
  width: auto !important;;
  margin-top: 3px;
}

.q-grid .fa-check {
  color: #17a700;
}

.q-grid .slick-column-name {
  margin-bottom: 0px;
  float: left;
}

.q-grid .slick-resizable-handle {
  width: 1px;
  background-color: #c5c5c5;
  border-left: 3px solid rgb(245, 245, 245);
  border-right: 3px solid rgb(245, 245, 245);
}

.q-grid .slick-resizable-handle.active {
  border-right-color: #deeaf7;
}

.q-grid .slick-cell {
  border-bottom: 1px solid #e1e8ed;
  border-right: none;
  border-left: 1px solid transparent;
  font-size: 13px;
  padding-left: 0px;
  padding-top: 4px;
  border-top: none;
}

.q-grid.highlight-selected-row .slick-cell.selected {
  background-color: #deeaf7;
}

.q-grid.highlight-selected-cell .slick-cell.active {
  border: 2px solid rgb(65, 165, 245);
  padding-top: 2px;
  padding-bottom: 1px;
  padding-left: 3px;
}

.q-grid .slick-cell.editable:not(.idx-col) {
  border: 2px solid rgb(65, 165, 245);
  padding-top: 2px;
  padding-bottom: 1px;
  padding-left: 3px !important;
  background-color: #FFF;
  -webkit-box-shadow: 0 2px 5px rgba(0,0,0,0.4);
  -moz-box-shadow: 0 2px 5px rgba(0,0,0,0.4);
  box-shadow: 0 2px 5px rgba(0,0,0,0.4);
}

.q-grid .slick-cell.editable .editor-select:focus {
  outline-style: none;
}

.q-grid .slick-cell.idx-col {
  font-weight: bold;
  margin-right: 3px;
}

.q-grid .slick-cell.idx-col.last-idx-col {
  border-right: 1px solid rgb(225, 232, 237);
}

.q-grid .slick-cell.idx-col:not(.first-idx-col) {
  font-weight: bold;
  border-left: 1px solid rgb(225, 232, 237);
  margin-right: 3px;
}

.q-grid .idx-col.group-top {
  border-bottom-color: transparent;
  background-color: #FFF;
}

.q-grid .idx-col.group-middle {
  border-top-color: transparent;
  border-bottom-color: transparent;
  color: transparent;
  background-color: #FFF;
}

.q-grid .idx-col.group-bottom {
  border-top-color: transparent;
  color: transparent;
  background-color: #FFF;
}

.q-grid .idx-col.group-single {
  background-color: transparent;
}

.q-grid .slick-cell.l0.r0 {
  border-left: none;
  padding-left: 6px;
  z-index: 85;
}

.q-grid .slick-cell.l1.r1 {
  z-index: 86;
}

.q-grid .slick-cell.l2.r2 {
  z-index: 87;
}

.q-grid .slick-cell.l3.r3 {
  z-index: 88;
}

.q-grid .slick-cell.l4.r4 {
  z-index: 89;
}

.q-grid .slick-cell.l5.r5 {
  z-index: 90;
}

.q-grid .slick-cell.editable {
  z-index: 91 !important;
}

.q-grid .slick-cell.selected {
  background-color: transparent;
}

/* Filter button */

.q-grid .slick-header-column.active .filter-button, .filter-button:hover {
  background-color: #deeaf7;
  border-left: 1px solid #cccccc;
}

.q-grid .slick-header-column.filter-button-disabled .filter-button {
  color: #bababa;
}

.q-grid .filter-button {
  position: absolute;
  right: 4px;
  top: 0px;
  line-height: 29px;
  height: 28px;
  width: 21px;
  text-align: center;
  z-index: 10;
  background-image: none;
  margin-top: 0px;
}

.q-grid .filter-button:hover {
  background-color: #efefef;
  border-left: 1px solid #cccccc;
}

/* Filter dropdowns */

.q-grid-container .grid-filter {
  z-index: 1000;
  position: absolute;
  padding: 0px;
  margin: 0px;
  max-height: 400px;
  display: block;
  border-radius: 0px;
  /* we previously got these style from bootstrap */
  float: left;
  min-width: 160px;
  list-style: none;
  font-size: 13px;
  text-align: left;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-clip: padding-box;
}

.q-grid-container .filter-error-msg {
  padding: 8px 14px;
  width: 160px;
}

.q-grid-container .grid-filter h3.qgrid-popover-title {
  padding: 5px 30px 5px 11px;
  border-bottom: 1px solid #d3d3d3;
  border-radius: 0px;
  /* we previously got these style from bootstrap */
  margin: 0;
  font-size: 13px;
  background-color: #f7f7f7;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
  display: block;
}

.q-grid-container .grid-filter .dropdown-title {
  font-size: 13px;
}

.q-grid-container .grid-filter i.close-button {
  position: absolute;
  right: 11px;
  top: 7px;
  padding: 0;
  color: #ababab;
  cursor: pointer;
  background-image: none;
  margin-top: 0px;
}

.q-grid-container .grid-filter i.close-button:hover {
  color: #777777;
}

.q-grid-container .grid-filter .dropdown-footer {
  background-color: #f7f7f7;
  border-top: 1px solid #d3d3d3;
  padding: 4px 12px;
  height: 19px;
}

.q-grid-container .grid-filter .dropdown-footer a.reset-link {
  padding: 0px;
  float: right;
}

.q-grid-container .grid-filter .dropdown-footer a.select-all-link {
  padding: 0px;
}

.q-grid-container .date-range-filter .dropdown-body {
  margin: 15px 11px;
  width: 210px;
}

.q-grid-container .date-range-filter .start-date {
  margin-right: 4px;
  width: 80px;
}

.q-grid-container .date-range-filter .end-date {
  margin-left: 4px;
  width: 80px;
}

.q-grid-container .numerical-filter .dropdown-body {
  margin: 20px 23px 10px 20px;
  width: 207px;
  text-align: center;
}

.q-grid-container .numerical-filter .slider-range {
  margin-bottom: 4px;
}


.q-grid-container .numerical-filter .ui-slider-handle {
  width: 18px;
  padding: 0;
}

.q-grid-container .numerical-filter .range-separator {
  font-size: 28px;
  font-weight: 300;
  padding: 0 7px;
  color: #646a76;
  position: relative;
  top: 4px;
}

.text-filter-grid * {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.text-filter .slick-viewport {
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.text-filter .input-area {
  padding: 12px;
}

.text-filter .no-results {
  margin-left: 12px;
  margin-bottom: 10px;
}

.text-filter .search-input {
  height: 30px;
  width: 100%;
  margin-bottom: 0px;
  box-sizing: border-box;
}

.text-filter .text-filter-grid {
  width: 300px;
  height: 250px;
  box-sizing: border-box;
  border-top: 1px solid #d3d3d3;
}

.text-filter .slick-header {
  border: none;
}

.text-filter .slick-header-columns {
  height: 0px;
}

.text-filter .slick-cell {
  line-height: 30px;
  border-left: none;
  border-right: none;
  background-color: #ffffff !important;
  border-bottom: 1px solid #e1e8ed !important;
  padding: 0;
  text-align: left;
  cursor: pointer;
}

.text-filter .slick-row.odd .slick-cell {
  background: #fafafa !important;
}

.text-filter .slick-row.active .slick-cell {
  background-color: #deeaf7 !important;
  border-top: 1px solid transparent !important;
}

.text-filter .check-box-cell {
  text-align: center;
  line-height: 28px;
}

.text-filter .check-box-cell input {
  margin: 0;
}

/* from custom-bootstrap *****************/

.q-grid-container input.datepicker {
  padding: 4px 4px 2px 4px;
  border: 1px solid lightgrey;
  font-size: 13px;
  line-height: 18px;
}

/* jquery-ui overrides */

.ui-widget, .ui-widget input, .ui-widget select, .ui-widget textarea, .ui-widget button {
  font-family: inherit !important;
  font-size: 13px;
}

.ui-tooltip {
  opacity: 1.0 !important;
}

/* jquery-ui datepicker style overrides */

#ui-datepicker-div {
  z-index: 9999 !important;
}

#ui-datepicker-div.ui-datepicker {
  /*@include box-shadow(0 5px 10px rgba(0, 0, 0, 0.2))*/
  z-index: 9999 !important;
  padding: 0 !important;
  background-color: white;
  border: 1px solid gray;
}

#ui-datepicker-div.ui-datepicker .ui-icon {
  display: inline-block;
  font-family: "Font Awesome 5 Free", FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-indent: 0px;
  margin-left: -4px;
  margin-top: -6px;
  background-image: none;
}

#ui-datepicker-div.ui-datepicker .ui-icon-circle-triangle-w:before {
    content: "\\f053";
    font-weight: bold !important;
}

#ui-datepicker-div.ui-datepicker .ui-icon-circle-triangle-e:before {
    content: "\\f054";
    font-weight: bold !important;
}


/* from slickgrid editing example */
input.editor-text {
  width: 100%;
  height: 100%;
  border: 0;
  margin: -1px 0 0 0;
  background: transparent;
  outline: 0;
  padding: 0;
}

.ui-datepicker-trigger {
  width: 16px;
  height: 16px;
  margin-top: 2px;
  padding: 0;
  vertical-align: top;
  left: 4px;
  position: relative;
}

.slick-cell.boolean {
  text-align: center;
}

.bool-radio-wrapper {
  position: relative;
  margin: 8px auto 4px auto;
}

.label-true {
  padding: 4px 28px 4px 13px;
}

.label-false {
  padding: 4px 28px 4px 4px;
  margin-left: 15px;
}

input.bool-filter-radio {
  margin-left: -23px;
}

.slick-cell {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none;
}

.slick-row .slick-cell:not(:first-child) {
  padding-left: 5px;
  margin-left: -4px;
}

.q-grid .slick-sort-indicator-desc,
.q-grid .slick-sort-indicator-asc {
  background-image: none;
}




/* ========= Dark Mode CSS ========== */

body.qgrid-dark-mode .q-grid-container,
body.qgrid-dark-mode .slick-row.even {
  background-color: #111111;
  color: #e4e4e4;
}
body.qgrid-dark-mode .slick-row.odd {
  background-color: #212121;
  color: #e4e4e4;
}
body.qgrid-dark-mode .slick-row .editor-text {
  color: #e4e4e4;
}
body.qgrid-dark-mode .q-grid.highlight-selected-row .slick-cell.selected {
  background-color: #1c2f3e;
}
body.qgrid-dark-mode .q-grid .fa-check {
  color: #9ac9f5;
}
body.qgrid-dark-mode .q-grid {
  border-color: #474747;
}
body.qgrid-dark-mode .q-grid .slick-cell {
  border-bottom-color: rgb(17, 17, 17);
}
body.qgrid-dark-mode .q-grid .slick-header-column {
  background-color: #111111;
  color: #ededed;
}
body.qgrid-dark-mode .q-grid .slick-resizable-handle {
  background-color: #474747;
  border-color: #111111;
}
body.qgrid-dark-mode .slick-header.ui-state-default {
  border-color: #474747;
}
body.qgrid-dark-mode .q-grid .filter-button:hover,
body.qgrid-dark-mode .q-grid .slick-header-column.active .filter-button {
  background-color: #474747 !important;
  border: none;
}
body.qgrid-dark-mode .q-grid .slick-header-column .filter-button.filter-active,
body.qgrid-dark-mode .q-grid .slick-header-column .filter-button.filter-active:hover{
  background-color: #474747 !important;
  border-left: none;
}

body.qgrid-dark-mode .q-grid.force-fit-columns .slick-header-column:last-child .filter-button {
  border-right-color: #111111 !important;
}

body.qgrid-dark-mode .q-grid.force-fit-columns .slick-header-column:last-child .filter-button.filter-active,
body.qgrid-dark-mode .q-grid.force-fit-columns .slick-header-column:last-child .filter-button:hover,
body.qgrid-dark-mode .q-grid.force-fit-columns .slick-header-column.active:last-child .filter-button {
  border-right-color: #474747 !important;
}

body.qgrid-dark-mode .q-grid .slick-header-columns {
  background-color: #474747 !important;
}

body.qgrid-dark-mode .q-grid .slick-viewport {
  scrollbar-color: #9e9e9e #71717147;
}

body.qgrid-dark-mode .grid-canvas .slick-row:last-child {
  border-bottom: 1px solid #474747;
}


/* Dark mode for MultiIndex */
body.qgrid-dark-mode .q-grid .idx-col.group-top,
body.qgrid-dark-mode .q-grid .idx-col.group-middle,
body.qgrid-dark-mode .q-grid .idx-col.group-bottom {
  background-color: #111111;
}
body.qgrid-dark-mode .q-grid .idx-col.group-bottom {
  border-bottom: 1px solid #474747;
}
body.qgrid-dark-mode .q-grid .slick-cell.idx-col.last-idx-col {
  border-right-color: #474747;
}
body.qgrid-dark-mode .q-grid .slick-cell.idx-col.last-idx-col.group-single {
  border-right: none;
}
body.qgrid-dark-mode .q-grid .slick-cell.idx-col:not(.first-idx-col) {
  border-left-color: #474747;
}



/* Dark mode for filters */

body.qgrid-dark-mode .q-grid-container .grid-filter {
  background-color: #111111;
  border-color: #ffffff26;
  box-shadow: 0 6px 12px #20202026;
}
body.qgrid-dark-mode .q-grid-container .grid-filter h3.qgrid-popover-title {
  background-color: #252525;
  border-bottom: none;
}
body.qgrid-dark-mode .q-grid-container .grid-filter .dropdown-footer {
  background-color: #111111;
  border: none;
  padding-top: 0;
  padding-bottom: 8px;
}
body.qgrid-dark-mode .q-grid-container a {
  color: #d4ebff !important;
}

/* Dark mode for text filter */
body.qgrid-dark-mode .text-filter .slick-cell {
  background-color: rgb(17, 17, 17) !important;
  border-bottom-color: #222222 !important;
}
body.qgrid-dark-mode .text-filter .slick-row.odd .slick-cell {
  background-color: rgb(33, 33, 33) !important;
}
body.qgrid-dark-mode .text-filter .text-filter-grid {
  border-top-color: #333333;
}

/* Dark mode for <input> */
body.qgrid-dark-mode .q-grid-container input {
  background-color: #2c2c2c;
  color: #ffffff;
  border: 1px solid #555555;
  border-radius: 3px;
  transition: background-color 0.3s, border-color 0.3s;
}

body.qgrid-dark-mode .q-grid-container input::placeholder {
  color: #aaaaaa;
}

body.qgrid-dark-mode .q-grid-container input:focus {
  background-color: #3a3a3a;
  border-color: #888888;
  outline: none;
}

/* Dark mode for sliders */
body.qgrid-dark-mode .q-grid-container .numerical-filter .range-separator {
  color: #cccccc;
}

body.qgrid-dark-mode .q-grid-container .slider-range {
  border-color: #555555;
}

body.qgrid-dark-mode .q-grid-container .ui-slider {
  background-color: #333333;
  border-color: #444444;
}

body.qgrid-dark-mode .q-grid-container .numerical-filter .ui-slider-handle {
  background-color: #cccccc;
  border-color: #777777;
}

body.qgrid-dark-mode .q-grid-container .numerical-filter .ui-slider-handle:hover,
body.qgrid-dark-mode .q-grid-container .numerical-filter .ui-slider-handle:active {
  background-color: #777777;
  border-color: #999999;
}

body.qgrid-dark-mode .q-grid-container .numerical-filter .ui-slider-range {
  background-color: #8b8b8b;
  border-radius: 5px;
}



/* Dark mode styles for jQuery UI DatePicker */
body.qgrid-dark-mode .ui-datepicker {
  background-color: #1a1a1a;
  color: #e0e0e0;
  border: 1px solid #404040;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}
body.qgrid-dark-mode #ui-datepicker-div.ui-datepicker {
  background-color: #404040;
}
body.qgrid-dark-mode .ui-datepicker .ui-datepicker-header {
  background-color: #2d2d2d;
  border: 1px solid #404040;
  color: #ffffff;
}
body.qgrid-dark-mode .ui-datepicker .ui-datepicker-title {
  color: #ffffff;
}
body.qgrid-dark-mode .ui-datepicker .ui-widget-header .ui-datepicker-prev,
body.qgrid-dark-mode .ui-datepicker .ui-widget-header .ui-datepicker-next {
  background-color: #2d2d2d;
  color: #dddddd;
}
body.qgrid-dark-mode .ui-datepicker .ui-widget-header .ui-datepicker-prev-hover,
body.qgrid-dark-mode .ui-datepicker .ui-widget-header .ui-datepicker-next-hover {
  color: #dddddd;
}
body.qgrid-dark-mode .ui-datepicker .ui-datepicker-prev:hover,
body.qgrid-dark-mode .ui-datepicker .ui-datepicker-next:hover {
  background-color: #404040;
  border-color: #505050;
}
body.qgrid-dark-mode .ui-datepicker th {
  background-color: #2d2d2d;
  color: #ffffff;
  border: none;
}
body.qgrid-dark-mode .ui-datepicker .ui-state-default {
  background-color: #333333;
  color: #e0e0e0;
  border: 1px solid #404040;
  text-align: center;
}
body.qgrid-dark-mode .ui-datepicker .ui-state-default:hover {
  background-color: #404040;
  color: #ffffff;
}
body.qgrid-dark-mode .ui-datepicker .ui-state-active {
  background-color: #0066cc;
  color: #ffffff;
  border-color: #0077ee;
}
body.qgrid-dark-mode .ui-datepicker .ui-state-highlight {
  background-color: #404040;
  color: #ffffff;
  border-color: #505050;
}
body.qgrid-dark-mode .ui-datepicker .ui-state-disabled {
  opacity: 0.35;
  background-color: #282828;
}
body.qgrid-dark-mode .ui-datepicker .ui-state-disabled .ui-state-default {
  background-color: transparent;
  color: #808080;
}
body.qgrid-dark-mode .ui-datepicker .ui-datepicker-week-end {
  background-color: #262626;
}
body.qgrid-dark-mode .ui-datepicker .ui-datepicker-other-month .ui-state-default {
  background-color: #1f1f1f;
  color: #666666;
}

/* Dark mode for vscode */
:root {
  --jp-widgets-color: var(--vscode-editor-foreground);
  --jp-widgets-font-size: var(--vscode-editor-font-size);
}
body.qgrid-dark-mode .cell-output-ipywidget-background {
  background-color: transparent !important;
}
`, "",{"version":3,"sources":["webpack://./src/qgrid.css"],"names":[],"mappings":";AACA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB;+CAC6C;EAC7C,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,SAAS;EACT,UAAU;EACV,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;;;EAGE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;;EAEE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;EACtB,6CAA6C;EAC7C,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,kBAAkB;;AAElB;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,qBAAqB;;AAErB;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,iDAAiD;EACjD,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,kBAAkB;EAClB,iDAAiD;EACjD,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,2CAA2C;EAC3C,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA,0CAA0C;;AAE1C;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;AACnB;;AAEA,wBAAwB;;AAExB;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,yCAAyC;;AAEzC;EACE,wBAAwB;AAC1B;;AAEA;EACE,qDAAqD;EACrD,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;EAC/C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;AAChC;;;AAGA,mCAAmC;AACnC;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B,EAAE,eAAe;IAC1C,yBAAyB,EAAE,WAAW;KACrC,wBAAwB,EAAE,mBAAmB;OAC3C,sBAAsB,EAAE,YAAY;QACnC,qBAAqB,EAAE,2BAA2B;YAC9C,iBAAiB;AAC7B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;AACxB;;;;;AAKA,uCAAuC;;AAEvC;;EAEE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,oCAAoC;EACpC,YAAY;AACd;AACA;;EAEE,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;;EAGE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;;AAGA,6BAA6B;AAC7B;;;EAGE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;;;;AAIA,0BAA0B;;AAE1B;EACE,yBAAyB;EACzB,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,4CAA4C;EAC5C,uCAAuC;AACzC;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;;;AAIA,8CAA8C;AAC9C;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,yCAAyC;AAC3C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,mDAAmD;EACnD,sDAAsD;AACxD;AACA;EACE,wCAAwC;AAC1C","sourcesContent":["\n.q-grid-container * {\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\n.q-grid-container {\n  position: relative;\n  overflow-x: auto;\n  width: auto;\n  height: auto;\n  border-radius: 4px;\n  color: #111111;\n}\n\n.q-grid-container .hidden {\n  display: none !important;\n}\n\n.q-grid-container a {\n  color: #337ab7 !important;\n  text-decoration: none;\n  line-height: 20px;\n}\n\n.q-grid-container a:hover,\n.q-grid-container a:focus {\n  color: #23527c;\n  text-decoration: underline;\n}\n\n.q-grid {\n  position: relative;\n  border: 1px solid #d3d3d3;\n  margin-top: 6px;\n  margin-bottom: 2px;\n  box-sizing: border-box;\n}\n\n.q-grid-toolbar {\n  margin: 4px 0\n}\n\n.q-grid-toolbar .btn {\n  background-color: #EEEEEE;\n  border-color: #E0E0E0;\n  margin-right: 6px;\n  padding: 4px 40px;\n  /* taken from bootstrap's btn class, since\n     jupyterlab doesn't include bootstrap css */\n  display: inline-block;\n  margin-bottom: 0;\n  font-weight: normal;\n  text-align: center;\n  vertical-align: middle;\n  touch-action: manipulation;\n  cursor: pointer;\n  background-image: none;\n  border: 1px solid #E0E0E0;\n  white-space: nowrap;\n  font-size: 13px;\n  line-height: 1.42857143;\n  border-radius: 2px;\n}\n\n.q-grid-toolbar .btn:hover {\n  background-color: #DDDDDD;\n  border-color: #CCCCCC;\n}\n\n.q-grid-toolbar .btn:focus {\n  outline: none;\n}\n\n.q-grid-toolbar .close-modal-btn {\n  display: none;\n}\n\n.qgrid-modal .q-grid-toolbar .close-modal-btn {\n  display: block;\n}\n\n.qgrid-modal .full-screen-btn,\n.qgrid-modal .modal-header,\n.qgrid-modal .modal-footer {\n  display: none;\n}\n\n.qgrid-modal {\n  width: 100%;\n  height: 100%;\n  margin: 0px;\n}\n\n.qgrid-modal .modal-content {\n  position: absolute;\n  left: 0px;\n  right: 0px;\n  top: 0px;\n  bottom: 0px;\n}\n\n.qgrid-modal .modal-body {\n  position: absolute;\n  padding: 15px;\n  top: 0px;\n  left: 0px;\n  bottom: 0px;\n  right: 0px;\n}\n\n.qgrid-modal .modal-body button.close {\n  margin-top: 7px;\n  margin-right: 14px;\n}\n\n.qgrid-modal .q-grid-container {\n  bottom: 25px;\n  left: 20px;\n  right: 20px;\n  position: absolute;\n  top: 15px;\n}\n\n.qgrid-modal .q-grid {\n  position: absolute;\n  top: 33px;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  height: auto !important;\n}\n\n.q-grid-toolbar .full-screen-btn,\n.q-grid-toolbar .close-modal-btn {\n  height: 18px;\n  width: 12px;\n  padding: 4px 7px;\n  float: right;\n  margin-right: 0px;\n}\n\n.output_scroll .q-grid {\n  height: 315px !important;\n}\n\n.q-grid-toolbar {\n  display: none;\n}\n\n.show-toolbar .q-grid-toolbar {\n  display: block;\n}\n\n.output_scroll .show-toolbar .q-grid {\n  height: 284px !important;\n}\n\n.q-grid.force-fit-columns .slick-viewport {\n  overflow-x: hidden !important;\n}\n\n.q-grid.hide-scrollbar > .slick-header {\n  margin-bottom: -1px;\n}\n\n.q-grid.hide-scrollbar > .slick-viewport {\n  overflow-y: hidden !important;\n  height: 100%;\n}\n\n.q-grid.hide-scrollbar.force-fit-columns > .slick-viewport {\n  overflow: hidden !important;\n}\n\n.q-grid.hide-scrollbar > .slick-viewport > .grid-canvas {\n  margin-top: 1px;\n}\n\n.q-grid .slick-header {\n  border-top: none;\n  border-left: none;\n  border-right: none;\n}\n\n.q-grid .slick-header-columns,\n.text-filter-grid .slick-header-columns {\n  background: none;\n  background-color: rgb(245, 245, 245);\n  border-bottom: none;\n}\n\n.q-grid.force-fit-columns .slick-header-column:last-child .filter-button:hover,\n.q-grid.force-fit-columns .slick-header-column.active:last-child .filter-button,\n.q-grid.force-fit-columns .slick-header-column:last-child .filter-button.filter-active {\n  border-right: 1px solid #ccc;\n  margin-right: -4px;\n}\n\n.q-grid.force-fit-columns .slick-header-column:last-child .filter-button {\n  margin-right: -4px;\n  border-right: 1px solid transparent;\n}\n\n.q-qgrid.hide-scrollbar .slick-header-column:last-child .slick-resizable-handle {\n  right: -4px;\n}\n\n.q-grid.hide-scrollbar > .slick_header .slick-header-column:last-child .filter-button,\n.q-grid.hide-scrollbar > .slick-header .slick-header-column:last-child .filter-button:hover,\n.q-grid.hide-scrollbar > .slick-header .slick-header-column.active:last-child .filter-button:hover,\n.q-grid.hide-scrollbar > .slick-header .slick-header-column.active:last-child .filter-button.filter-active {\n  border-right: 1px solid transparent;\n}\n\n.q-grid .slick-header-column .filter-button.filter-active,\n.q-grid .slick-header-column .filter-button.filter-active:hover{\n  background-color: #deeaf7;\n  border-left: 1px solid #cccccc;\n}\n\n.q-grid .slick-header-column {\n  background: rgb(245, 245, 245);\n  color: #565656;\n  border-right-style: none;\n  font-size: 13px;\n  font-weight: bold;\n  padding: 6px 2px !important;\n}\n\n.q-grid .slick-header-column.active {\n  background-color: #deeaf7;\n}\n\n.q-grid .slick-header-column-sorted {\n  font-style: inherit !important;\n}\n\n.q-grid .slick-header-column:first-child .slick-column-name {\n  margin-left: 6px !important;\n}\n\n.q-grid .slick-sort-indicator {\n  height: 8px !important;\n  margin-left: 6px;\n}\n\n.q-grid .slick-sort-indicator.fa-sort-asc {\n  margin-top: 4px;\n  color: #5862ff;\n}\n\n.q-grid .slick-sort-indicator.fa-sort-desc {\n  margin-top: 1px;\n  color: #5862ff;\n}\n\n.q-grid .slick-sort-indicator.fa-spinner {\n  height: auto !important;;\n  width: auto !important;;\n  margin-top: 3px;\n}\n\n.q-grid .fa-check {\n  color: #17a700;\n}\n\n.q-grid .slick-column-name {\n  margin-bottom: 0px;\n  float: left;\n}\n\n.q-grid .slick-resizable-handle {\n  width: 1px;\n  background-color: #c5c5c5;\n  border-left: 3px solid rgb(245, 245, 245);\n  border-right: 3px solid rgb(245, 245, 245);\n}\n\n.q-grid .slick-resizable-handle.active {\n  border-right-color: #deeaf7;\n}\n\n.q-grid .slick-cell {\n  border-bottom: 1px solid #e1e8ed;\n  border-right: none;\n  border-left: 1px solid transparent;\n  font-size: 13px;\n  padding-left: 0px;\n  padding-top: 4px;\n  border-top: none;\n}\n\n.q-grid.highlight-selected-row .slick-cell.selected {\n  background-color: #deeaf7;\n}\n\n.q-grid.highlight-selected-cell .slick-cell.active {\n  border: 2px solid rgb(65, 165, 245);\n  padding-top: 2px;\n  padding-bottom: 1px;\n  padding-left: 3px;\n}\n\n.q-grid .slick-cell.editable:not(.idx-col) {\n  border: 2px solid rgb(65, 165, 245);\n  padding-top: 2px;\n  padding-bottom: 1px;\n  padding-left: 3px !important;\n  background-color: #FFF;\n  -webkit-box-shadow: 0 2px 5px rgba(0,0,0,0.4);\n  -moz-box-shadow: 0 2px 5px rgba(0,0,0,0.4);\n  box-shadow: 0 2px 5px rgba(0,0,0,0.4);\n}\n\n.q-grid .slick-cell.editable .editor-select:focus {\n  outline-style: none;\n}\n\n.q-grid .slick-cell.idx-col {\n  font-weight: bold;\n  margin-right: 3px;\n}\n\n.q-grid .slick-cell.idx-col.last-idx-col {\n  border-right: 1px solid rgb(225, 232, 237);\n}\n\n.q-grid .slick-cell.idx-col:not(.first-idx-col) {\n  font-weight: bold;\n  border-left: 1px solid rgb(225, 232, 237);\n  margin-right: 3px;\n}\n\n.q-grid .idx-col.group-top {\n  border-bottom-color: transparent;\n  background-color: #FFF;\n}\n\n.q-grid .idx-col.group-middle {\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  color: transparent;\n  background-color: #FFF;\n}\n\n.q-grid .idx-col.group-bottom {\n  border-top-color: transparent;\n  color: transparent;\n  background-color: #FFF;\n}\n\n.q-grid .idx-col.group-single {\n  background-color: transparent;\n}\n\n.q-grid .slick-cell.l0.r0 {\n  border-left: none;\n  padding-left: 6px;\n  z-index: 85;\n}\n\n.q-grid .slick-cell.l1.r1 {\n  z-index: 86;\n}\n\n.q-grid .slick-cell.l2.r2 {\n  z-index: 87;\n}\n\n.q-grid .slick-cell.l3.r3 {\n  z-index: 88;\n}\n\n.q-grid .slick-cell.l4.r4 {\n  z-index: 89;\n}\n\n.q-grid .slick-cell.l5.r5 {\n  z-index: 90;\n}\n\n.q-grid .slick-cell.editable {\n  z-index: 91 !important;\n}\n\n.q-grid .slick-cell.selected {\n  background-color: transparent;\n}\n\n/* Filter button */\n\n.q-grid .slick-header-column.active .filter-button, .filter-button:hover {\n  background-color: #deeaf7;\n  border-left: 1px solid #cccccc;\n}\n\n.q-grid .slick-header-column.filter-button-disabled .filter-button {\n  color: #bababa;\n}\n\n.q-grid .filter-button {\n  position: absolute;\n  right: 4px;\n  top: 0px;\n  line-height: 29px;\n  height: 28px;\n  width: 21px;\n  text-align: center;\n  z-index: 10;\n  background-image: none;\n  margin-top: 0px;\n}\n\n.q-grid .filter-button:hover {\n  background-color: #efefef;\n  border-left: 1px solid #cccccc;\n}\n\n/* Filter dropdowns */\n\n.q-grid-container .grid-filter {\n  z-index: 1000;\n  position: absolute;\n  padding: 0px;\n  margin: 0px;\n  max-height: 400px;\n  display: block;\n  border-radius: 0px;\n  /* we previously got these style from bootstrap */\n  float: left;\n  min-width: 160px;\n  list-style: none;\n  font-size: 13px;\n  text-align: left;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  background-clip: padding-box;\n}\n\n.q-grid-container .filter-error-msg {\n  padding: 8px 14px;\n  width: 160px;\n}\n\n.q-grid-container .grid-filter h3.qgrid-popover-title {\n  padding: 5px 30px 5px 11px;\n  border-bottom: 1px solid #d3d3d3;\n  border-radius: 0px;\n  /* we previously got these style from bootstrap */\n  margin: 0;\n  font-size: 13px;\n  background-color: #f7f7f7;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n  display: block;\n}\n\n.q-grid-container .grid-filter .dropdown-title {\n  font-size: 13px;\n}\n\n.q-grid-container .grid-filter i.close-button {\n  position: absolute;\n  right: 11px;\n  top: 7px;\n  padding: 0;\n  color: #ababab;\n  cursor: pointer;\n  background-image: none;\n  margin-top: 0px;\n}\n\n.q-grid-container .grid-filter i.close-button:hover {\n  color: #777777;\n}\n\n.q-grid-container .grid-filter .dropdown-footer {\n  background-color: #f7f7f7;\n  border-top: 1px solid #d3d3d3;\n  padding: 4px 12px;\n  height: 19px;\n}\n\n.q-grid-container .grid-filter .dropdown-footer a.reset-link {\n  padding: 0px;\n  float: right;\n}\n\n.q-grid-container .grid-filter .dropdown-footer a.select-all-link {\n  padding: 0px;\n}\n\n.q-grid-container .date-range-filter .dropdown-body {\n  margin: 15px 11px;\n  width: 210px;\n}\n\n.q-grid-container .date-range-filter .start-date {\n  margin-right: 4px;\n  width: 80px;\n}\n\n.q-grid-container .date-range-filter .end-date {\n  margin-left: 4px;\n  width: 80px;\n}\n\n.q-grid-container .numerical-filter .dropdown-body {\n  margin: 20px 23px 10px 20px;\n  width: 207px;\n  text-align: center;\n}\n\n.q-grid-container .numerical-filter .slider-range {\n  margin-bottom: 4px;\n}\n\n\n.q-grid-container .numerical-filter .ui-slider-handle {\n  width: 18px;\n  padding: 0;\n}\n\n.q-grid-container .numerical-filter .range-separator {\n  font-size: 28px;\n  font-weight: 300;\n  padding: 0 7px;\n  color: #646a76;\n  position: relative;\n  top: 4px;\n}\n\n.text-filter-grid * {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.text-filter .slick-viewport {\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n}\n\n.text-filter .input-area {\n  padding: 12px;\n}\n\n.text-filter .no-results {\n  margin-left: 12px;\n  margin-bottom: 10px;\n}\n\n.text-filter .search-input {\n  height: 30px;\n  width: 100%;\n  margin-bottom: 0px;\n  box-sizing: border-box;\n}\n\n.text-filter .text-filter-grid {\n  width: 300px;\n  height: 250px;\n  box-sizing: border-box;\n  border-top: 1px solid #d3d3d3;\n}\n\n.text-filter .slick-header {\n  border: none;\n}\n\n.text-filter .slick-header-columns {\n  height: 0px;\n}\n\n.text-filter .slick-cell {\n  line-height: 30px;\n  border-left: none;\n  border-right: none;\n  background-color: #ffffff !important;\n  border-bottom: 1px solid #e1e8ed !important;\n  padding: 0;\n  text-align: left;\n  cursor: pointer;\n}\n\n.text-filter .slick-row.odd .slick-cell {\n  background: #fafafa !important;\n}\n\n.text-filter .slick-row.active .slick-cell {\n  background-color: #deeaf7 !important;\n  border-top: 1px solid transparent !important;\n}\n\n.text-filter .check-box-cell {\n  text-align: center;\n  line-height: 28px;\n}\n\n.text-filter .check-box-cell input {\n  margin: 0;\n}\n\n/* from custom-bootstrap *****************/\n\n.q-grid-container input.datepicker {\n  padding: 4px 4px 2px 4px;\n  border: 1px solid lightgrey;\n  font-size: 13px;\n  line-height: 18px;\n}\n\n/* jquery-ui overrides */\n\n.ui-widget, .ui-widget input, .ui-widget select, .ui-widget textarea, .ui-widget button {\n  font-family: inherit !important;\n  font-size: 13px;\n}\n\n.ui-tooltip {\n  opacity: 1.0 !important;\n}\n\n/* jquery-ui datepicker style overrides */\n\n#ui-datepicker-div {\n  z-index: 9999 !important;\n}\n\n#ui-datepicker-div.ui-datepicker {\n  /*@include box-shadow(0 5px 10px rgba(0, 0, 0, 0.2))*/\n  z-index: 9999 !important;\n  padding: 0 !important;\n  background-color: white;\n  border: 1px solid gray;\n}\n\n#ui-datepicker-div.ui-datepicker .ui-icon {\n  display: inline-block;\n  font-family: \"Font Awesome 5 Free\", FontAwesome;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-indent: 0px;\n  margin-left: -4px;\n  margin-top: -6px;\n  background-image: none;\n}\n\n#ui-datepicker-div.ui-datepicker .ui-icon-circle-triangle-w:before {\n    content: \"\\f053\";\n    font-weight: bold !important;\n}\n\n#ui-datepicker-div.ui-datepicker .ui-icon-circle-triangle-e:before {\n    content: \"\\f054\";\n    font-weight: bold !important;\n}\n\n\n/* from slickgrid editing example */\ninput.editor-text {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  margin: -1px 0 0 0;\n  background: transparent;\n  outline: 0;\n  padding: 0;\n}\n\n.ui-datepicker-trigger {\n  width: 16px;\n  height: 16px;\n  margin-top: 2px;\n  padding: 0;\n  vertical-align: top;\n  left: 4px;\n  position: relative;\n}\n\n.slick-cell.boolean {\n  text-align: center;\n}\n\n.bool-radio-wrapper {\n  position: relative;\n  margin: 8px auto 4px auto;\n}\n\n.label-true {\n  padding: 4px 28px 4px 13px;\n}\n\n.label-false {\n  padding: 4px 28px 4px 4px;\n  margin-left: 15px;\n}\n\ninput.bool-filter-radio {\n  margin-left: -23px;\n}\n\n.slick-cell {\n  -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n     -khtml-user-select: none; /* Konqueror HTML */\n       -moz-user-select: none; /* Firefox */\n        -ms-user-select: none; /* Internet Explorer/Edge */\n            user-select: none;\n}\n\n.slick-row .slick-cell:not(:first-child) {\n  padding-left: 5px;\n  margin-left: -4px;\n}\n\n.q-grid .slick-sort-indicator-desc,\n.q-grid .slick-sort-indicator-asc {\n  background-image: none;\n}\n\n\n\n\n/* ========= Dark Mode CSS ========== */\n\nbody.qgrid-dark-mode .q-grid-container,\nbody.qgrid-dark-mode .slick-row.even {\n  background-color: #111111;\n  color: #e4e4e4;\n}\nbody.qgrid-dark-mode .slick-row.odd {\n  background-color: #212121;\n  color: #e4e4e4;\n}\nbody.qgrid-dark-mode .slick-row .editor-text {\n  color: #e4e4e4;\n}\nbody.qgrid-dark-mode .q-grid.highlight-selected-row .slick-cell.selected {\n  background-color: #1c2f3e;\n}\nbody.qgrid-dark-mode .q-grid .fa-check {\n  color: #9ac9f5;\n}\nbody.qgrid-dark-mode .q-grid {\n  border-color: #474747;\n}\nbody.qgrid-dark-mode .q-grid .slick-cell {\n  border-bottom-color: rgb(17, 17, 17);\n}\nbody.qgrid-dark-mode .q-grid .slick-header-column {\n  background-color: #111111;\n  color: #ededed;\n}\nbody.qgrid-dark-mode .q-grid .slick-resizable-handle {\n  background-color: #474747;\n  border-color: #111111;\n}\nbody.qgrid-dark-mode .slick-header.ui-state-default {\n  border-color: #474747;\n}\nbody.qgrid-dark-mode .q-grid .filter-button:hover,\nbody.qgrid-dark-mode .q-grid .slick-header-column.active .filter-button {\n  background-color: #474747 !important;\n  border: none;\n}\nbody.qgrid-dark-mode .q-grid .slick-header-column .filter-button.filter-active,\nbody.qgrid-dark-mode .q-grid .slick-header-column .filter-button.filter-active:hover{\n  background-color: #474747 !important;\n  border-left: none;\n}\n\nbody.qgrid-dark-mode .q-grid.force-fit-columns .slick-header-column:last-child .filter-button {\n  border-right-color: #111111 !important;\n}\n\nbody.qgrid-dark-mode .q-grid.force-fit-columns .slick-header-column:last-child .filter-button.filter-active,\nbody.qgrid-dark-mode .q-grid.force-fit-columns .slick-header-column:last-child .filter-button:hover,\nbody.qgrid-dark-mode .q-grid.force-fit-columns .slick-header-column.active:last-child .filter-button {\n  border-right-color: #474747 !important;\n}\n\nbody.qgrid-dark-mode .q-grid .slick-header-columns {\n  background-color: #474747 !important;\n}\n\nbody.qgrid-dark-mode .q-grid .slick-viewport {\n  scrollbar-color: #9e9e9e #71717147;\n}\n\nbody.qgrid-dark-mode .grid-canvas .slick-row:last-child {\n  border-bottom: 1px solid #474747;\n}\n\n\n/* Dark mode for MultiIndex */\nbody.qgrid-dark-mode .q-grid .idx-col.group-top,\nbody.qgrid-dark-mode .q-grid .idx-col.group-middle,\nbody.qgrid-dark-mode .q-grid .idx-col.group-bottom {\n  background-color: #111111;\n}\nbody.qgrid-dark-mode .q-grid .idx-col.group-bottom {\n  border-bottom: 1px solid #474747;\n}\nbody.qgrid-dark-mode .q-grid .slick-cell.idx-col.last-idx-col {\n  border-right-color: #474747;\n}\nbody.qgrid-dark-mode .q-grid .slick-cell.idx-col.last-idx-col.group-single {\n  border-right: none;\n}\nbody.qgrid-dark-mode .q-grid .slick-cell.idx-col:not(.first-idx-col) {\n  border-left-color: #474747;\n}\n\n\n\n/* Dark mode for filters */\n\nbody.qgrid-dark-mode .q-grid-container .grid-filter {\n  background-color: #111111;\n  border-color: #ffffff26;\n  box-shadow: 0 6px 12px #20202026;\n}\nbody.qgrid-dark-mode .q-grid-container .grid-filter h3.qgrid-popover-title {\n  background-color: #252525;\n  border-bottom: none;\n}\nbody.qgrid-dark-mode .q-grid-container .grid-filter .dropdown-footer {\n  background-color: #111111;\n  border: none;\n  padding-top: 0;\n  padding-bottom: 8px;\n}\nbody.qgrid-dark-mode .q-grid-container a {\n  color: #d4ebff !important;\n}\n\n/* Dark mode for text filter */\nbody.qgrid-dark-mode .text-filter .slick-cell {\n  background-color: rgb(17, 17, 17) !important;\n  border-bottom-color: #222222 !important;\n}\nbody.qgrid-dark-mode .text-filter .slick-row.odd .slick-cell {\n  background-color: rgb(33, 33, 33) !important;\n}\nbody.qgrid-dark-mode .text-filter .text-filter-grid {\n  border-top-color: #333333;\n}\n\n/* Dark mode for <input> */\nbody.qgrid-dark-mode .q-grid-container input {\n  background-color: #2c2c2c;\n  color: #ffffff;\n  border: 1px solid #555555;\n  border-radius: 3px;\n  transition: background-color 0.3s, border-color 0.3s;\n}\n\nbody.qgrid-dark-mode .q-grid-container input::placeholder {\n  color: #aaaaaa;\n}\n\nbody.qgrid-dark-mode .q-grid-container input:focus {\n  background-color: #3a3a3a;\n  border-color: #888888;\n  outline: none;\n}\n\n/* Dark mode for sliders */\nbody.qgrid-dark-mode .q-grid-container .numerical-filter .range-separator {\n  color: #cccccc;\n}\n\nbody.qgrid-dark-mode .q-grid-container .slider-range {\n  border-color: #555555;\n}\n\nbody.qgrid-dark-mode .q-grid-container .ui-slider {\n  background-color: #333333;\n  border-color: #444444;\n}\n\nbody.qgrid-dark-mode .q-grid-container .numerical-filter .ui-slider-handle {\n  background-color: #cccccc;\n  border-color: #777777;\n}\n\nbody.qgrid-dark-mode .q-grid-container .numerical-filter .ui-slider-handle:hover,\nbody.qgrid-dark-mode .q-grid-container .numerical-filter .ui-slider-handle:active {\n  background-color: #777777;\n  border-color: #999999;\n}\n\nbody.qgrid-dark-mode .q-grid-container .numerical-filter .ui-slider-range {\n  background-color: #8b8b8b;\n  border-radius: 5px;\n}\n\n\n\n/* Dark mode styles for jQuery UI DatePicker */\nbody.qgrid-dark-mode .ui-datepicker {\n  background-color: #1a1a1a;\n  color: #e0e0e0;\n  border: 1px solid #404040;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\nbody.qgrid-dark-mode #ui-datepicker-div.ui-datepicker {\n  background-color: #404040;\n}\nbody.qgrid-dark-mode .ui-datepicker .ui-datepicker-header {\n  background-color: #2d2d2d;\n  border: 1px solid #404040;\n  color: #ffffff;\n}\nbody.qgrid-dark-mode .ui-datepicker .ui-datepicker-title {\n  color: #ffffff;\n}\nbody.qgrid-dark-mode .ui-datepicker .ui-widget-header .ui-datepicker-prev,\nbody.qgrid-dark-mode .ui-datepicker .ui-widget-header .ui-datepicker-next {\n  background-color: #2d2d2d;\n  color: #dddddd;\n}\nbody.qgrid-dark-mode .ui-datepicker .ui-widget-header .ui-datepicker-prev-hover,\nbody.qgrid-dark-mode .ui-datepicker .ui-widget-header .ui-datepicker-next-hover {\n  color: #dddddd;\n}\nbody.qgrid-dark-mode .ui-datepicker .ui-datepicker-prev:hover,\nbody.qgrid-dark-mode .ui-datepicker .ui-datepicker-next:hover {\n  background-color: #404040;\n  border-color: #505050;\n}\nbody.qgrid-dark-mode .ui-datepicker th {\n  background-color: #2d2d2d;\n  color: #ffffff;\n  border: none;\n}\nbody.qgrid-dark-mode .ui-datepicker .ui-state-default {\n  background-color: #333333;\n  color: #e0e0e0;\n  border: 1px solid #404040;\n  text-align: center;\n}\nbody.qgrid-dark-mode .ui-datepicker .ui-state-default:hover {\n  background-color: #404040;\n  color: #ffffff;\n}\nbody.qgrid-dark-mode .ui-datepicker .ui-state-active {\n  background-color: #0066cc;\n  color: #ffffff;\n  border-color: #0077ee;\n}\nbody.qgrid-dark-mode .ui-datepicker .ui-state-highlight {\n  background-color: #404040;\n  color: #ffffff;\n  border-color: #505050;\n}\nbody.qgrid-dark-mode .ui-datepicker .ui-state-disabled {\n  opacity: 0.35;\n  background-color: #282828;\n}\nbody.qgrid-dark-mode .ui-datepicker .ui-state-disabled .ui-state-default {\n  background-color: transparent;\n  color: #808080;\n}\nbody.qgrid-dark-mode .ui-datepicker .ui-datepicker-week-end {\n  background-color: #262626;\n}\nbody.qgrid-dark-mode .ui-datepicker .ui-datepicker-other-month .ui-state-default {\n  background-color: #1f1f1f;\n  color: #666666;\n}\n\n/* Dark mode for vscode */\n:root {\n  --jp-widgets-color: var(--vscode-editor-foreground);\n  --jp-widgets-font-size: var(--vscode-editor-font-size);\n}\nbody.qgrid-dark-mode .cell-output-ipywidget-background {\n  background-color: transparent !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
